export const mapWithConcurrency = async (items, mapper, concurrency = 3) => {
  const source = Array.isArray(items) ? items : [];
  const limit = Math.max(1, Math.floor(concurrency) || 3);
  const results = new Array(source.length);
  let nextIndex = 0;

  const worker = async () => {
    while (nextIndex < source.length) {
      const currentIndex = nextIndex;
      nextIndex += 1;
      results[currentIndex] = await mapper(source[currentIndex], currentIndex, source);
    }
  };

  const workerCount = Math.min(limit, source.length);
  await Promise.all(Array.from({ length: workerCount }, worker));
  return results;
};

export default mapWithConcurrency;
